var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-icon',{staticClass:"mr-4"},[_c('v-img',{attrs:{"contain":"","height":"20px","width":"20px","src":_vm.img}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }